import i18n from "lib/i18n";
import { template } from "lodash";
import { View } from "backbone";
import CommentModeratorReasonView from "views/comment_moderator_reason_view";
/* eslint-disable
    constructor-super,
    func-names,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-multi-str,
    no-return-assign,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentModeratorControlsView;

export default CommentModeratorControlsView = (function () {
  CommentModeratorControlsView = class CommentModeratorControlsView extends View {
    static initClass() {
      this.prototype.className = "comment-editor-controls-view";

      this.prototype.events =
        { "click .remove": "_handleRemove" };

      this.prototype.template = template("\
<a class=\"moderation-control remove\" href=\"#\"><%- i18n.t('comment.button.remove') %></a>\
", { imports: { i18n } });
    }

    initialize(options) {
      this._handleRemove = this._handleRemove.bind(this);
      this.render();
      return this.comment = options.comment;
    }

    render() {
      return this.$el.html(this.template());
    }

    _handleRemove(event) {
      event.preventDefault();
      this.commentModeratorReasonView = new CommentModeratorReasonView({
        link: this.$el.find(".remove"),
        comment: this.comment,
      });
      this.commentModeratorReasonView.$el.appendTo(this.$el);
      return this.commentModeratorReasonView.on("reason:selected", data => this.trigger("comment:remove", data));
    }
  };
  CommentModeratorControlsView.initClass();
  return CommentModeratorControlsView;
}());
